<template>
<div class="chapter">
<div class="inner_page">
<p class="img"><img alt="art" src="images/Art_P002.jpg"/></p>
<p class="fmh1"><strong>THE FUTURE H<span class="small">OMEMAKERS OF AMERICA</span></strong></p>
<p class="p1"><em>The Future Homemakers of America</em> is Laurie Graham's sixth novel. Laurie is a former <em>Daily Telegraph</em> columnist and Contributing Editor for <em>Cosmopolitan.</em> She lives in Italy and is currently writing a screenplay of her novel <em>The Dress Circle.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FutureHomemake_fron-1.vue?7b46671c